var render, staticRenderFns
import script from "./OwnAirport.vue?vue&type=script&lang=js&"
export * from "./OwnAirport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45e4b119')) {
      api.createRecord('45e4b119', component.options)
    } else {
      api.reload('45e4b119', component.options)
    }
    
  }
}
component.options.__file = "src/mixins/OwnAirport.vue"
export default component.exports